module.exports = __webpack_public_path__ + "img/hdc.8336ed0f.jpg";